import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. 
        Eum odit minus expedita odio iusto et illo fugiat rem dolor necessitatibus perspiciatis non cumque voluptate 
        nihil, ab ipsam cupiditate veniam, sed tempora. Ex dicta est enim aliquid, odit aperiam labore rerum!</p>
    </section>
  )
}

export default About
